import React from 'react'
import PropTypes from 'prop-types'

const DashboardBox = ({ title, helpIcon, detailLink, detailText = 'View Detail', children }) => {
  const myDetailLink = detailLink ? (
    <a href={detailLink}>{detailText}</a>
  ) : (
    <div />
  )

  return (
    <div className="h-100 card-myed">
      <span className="pull-right">{helpIcon}</span>
      <h3>{title}</h3>
      <div>{children}</div>
      <div className="text-right" id="detail_link">
        {myDetailLink}
      </div>
    </div>
  )
}

DashboardBox.propTypes = {
  title: PropTypes.string.isRequired,
  helpIcon: PropTypes.element,
  detailLink: PropTypes.string,
  detailText: PropTypes.string,
}

export default DashboardBox
